<template>
  <v-main>
    <Navigation/>
    <router-view></router-view>
  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation.vue";

export default {
  name: 'PostOperativeCareTemplateIndex',
  components: { Navigation },
};
</script>
